import moment from 'moment';

import {
  LS_FIRST_LAUNCH_DATE,
  LS_LAST_TIME_POPUP_SHOWN,
  ANDROID_APP_ID,
  IOS_APP_STORE_URL,
} from 'constants/index';

const monthsDiff = date => {
  const now = moment();
  const givenDate = moment(date);
  const months = now.diff(givenDate, 'months');

  return Math.abs(months);
};

export const getDaysSinceInstallation = (
  installDate = new Date(localStorage.getItem(LS_FIRST_LAUNCH_DATE)),
) => {
  const now = moment();
  const install = moment(installDate);
  return now.diff(install, 'days');
};

export const canShowRatingDialog = () => {
  if (!window || !window.cordova) {
    return false;
  }

  if (!['ios', 'android'].includes(window.cordova.platformId)) {
    return false;
  }

  const installDate = new Date(localStorage.getItem(LS_FIRST_LAUNCH_DATE));
  const daysSinceInstall = getDaysSinceInstallation(installDate);
  const lastInvite = localStorage.getItem(LS_LAST_TIME_POPUP_SHOWN) || null;
  const monthsSinceLastShown = lastInvite ? monthsDiff(lastInvite) : null;

  return monthsSinceLastShown === null ? daysSinceInstall >= 14 : monthsSinceLastShown >= 4;
};

export const showRateUsPopUp = () => {
  if (!window || !window.cordova) {
    return Promise.reject(new Error("Can't show rate us pop-up on browser"));
  }

  if (window.cordova.platformId === 'ios') {
    window.open(IOS_APP_STORE_URL, '_system');

    return Promise.resolve('shown');
  }

  return new Promise(async (resolve, reject) => {
    if (!window.LaunchReview) {
      reject(new Error("Plugin isn't installed"));

      return;
    }

    window.LaunchReview.rating(resolve, reject, ANDROID_APP_ID);
  });
};
